import React, { Component } from 'react'

import ReactBootstrapSlider from 'react-bootstrap-slider';
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-slider/dist/css/bootstrap-slider.css"

export default class Range extends Component {

    constructor(props){
        super(props);
        this.state = {
            currentValue :8
        }
    }

    changeValue = (e) => {
        this.setState({currentValue: e.target.value})
    }

    onClickNext = () => {
        
        const {onClick} = this.props;
        const {currentValue} = this.state;

        if(currentValue > 3){ //minute, sec
            onClick(6,false);
        }
        else{ //hour, days, week
            onClick(5,false);
        }

    }

  render() {

    return (
      <div>

         <h1 className="text-center">How long do these feelings typically last?</h1>
         <div className="row">
        <ReactBootstrapSlider
            style={{width:"100%"}}
            value={this.state.currentValue}
            change={this.changeValue}
            slideStop={this.changeValue}
            step={1}
            max={8}
            min={0}
            orientation="horizontal"
            ticks = {[0,2,4,6,8]}
            ticks_labels = {['Weeks', 'Days', 'Hours', 'Minutes', 'Seconds']}
            // ticks_snap_bounds= {10}
            reversed={true}/>
          </div>
          <div className="text-center">
            <button className="btn btn-danger mt-5"  onClick={this.onClickNext}>Continue</button>
          </div>
      </div>
    )
  }
}
